export function getPaymentAmount(checkout) {
  return checkout.payNowTotalAfterGiftCard?.amount || '0';
}
//# sourceMappingURL=getPaymentAmount.js.map